import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from 'react';
import { Add } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Container } from '../../components/container';
import { BroadcastHistory } from './components/broadcast-history';
import { LoadingView } from '../../components/loading-view';
import { useHasPermission } from '../../core/auth/hooks/use-has-permission';
export const Broadcasts = () => {
    const canCreateBroadcast = useHasPermission('admin:broadcast:create');
    return (_jsx(Container, { children: _jsxs(Stack, { paddingY: 4, spacing: 3, children: [_jsx(Box, { children: _jsx(Button, { variant: "contained", startIcon: _jsx(Add, {}), component: Link, to: "create", disabled: !canCreateBroadcast, children: "Create broadcast" }) }), _jsx(Typography, { variant: "h5", children: "History" }), _jsx(Suspense, { fallback: _jsx(LoadingView, { height: "100%" }), children: _jsx(BroadcastHistory, {}) })] }) }));
};
